import type { SITE_THIRD_PARTY_SENSORS_TABLE_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/site-third-party-sensors-table/site-third-party-sensors-table.fr.ts";

export const SITE_THIRD_PARTY_SENSORS_TABLE_ENGLISH_LOCALE = {
  headers: {
    serialNumber: "Serial number",
    csId: "Cs Id",
    hwId: "Hardware Id",
    applianceCount: "Linked appliance count",
    installationDate: "Installation date",
  },
  empty: "No third party device found...",
} satisfies typeof SITE_THIRD_PARTY_SENSORS_TABLE_FRENCH_LOCALE;
